var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___SWdnMl",
  "pG": "ChannelOverviewTab.module__regionEmoji___SWdnMl",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___SWdnMl",
  "c5": "ChannelOverviewTab.module__topicInput___SWdnMl",
  "Z8": "ChannelOverviewTab.module__emojiButton___SWdnMl",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___SWdnMl",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___SWdnMl",
  "p9": "ChannelOverviewTab.module__sectionWrapper___SWdnMl",
  "h3": "ChannelOverviewTab.module__settingsGroup___SWdnMl",
  "hB": "ChannelOverviewTab.module__settingsControlRow___SWdnMl",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___SWdnMl",
  "Y4": "ChannelOverviewTab.module__settingsControlText___SWdnMl",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___SWdnMl",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___SWdnMl",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___SWdnMl",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___SWdnMl",
};

module.exports = exports;
